import type { UrlObj, PageTypeKey } from '@/config/types';;
export default class UrlPackage {
    // 一级页面。参考埋点需求填写即可
    page: string = '';
    // 参数列表参考埋点需求填写，并转成 json 字符串格式
    params?: {[key: string]: any};
    // 实例的全局唯一标识，使用UUID即可
    identity: string = '';
    // 应用页面类型
    page_type: 1 | 2 | 3 | 0;
    // 是否是半屏页
    coPage?: boolean;
    // 桥接新添加字段
    category?: string;
    constructor(url: UrlObj, pageType?: PageTypeKey) {
        switch (pageType) {
            case 'web':
                this.page_type = 2;
                break;
            case 'native':
                this.page_type = 1;
                break;
            case 'mina':
                this.page_type = 3;
                break;
            default:
                this.page_type = 0; // unknown
        }
        this.update(url.page, url.params);
    }

    // 更新urlPackage
    update(page: string = '', params?: any) {
        if (page && page !== this.page) {
            this.page = page;
            this.identity = this.generatePageId(page);
        }
        if (params) {
            this.params = Object.assign(this.params || {}, params);
        }
    }
    toJSON() {
        return {
            page: this.page,
            identity: this.identity,
            page_type: this.page_type,
            params: JSON.stringify(this.params),
            category: this.category,
        };
    }
    /**
     * 生成页面唯一id
     * 未自定义页面唯一ID生成方法，请自行添加后重新尝试
     * @param page
     */
    generatePageId(page: string) {
        return page + new Date().getTime();
    }
}
